import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Select, MenuItem, FormControl, InputLabel,
  Grid, Typography, IconButton, Slide
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { postData } from "../../BaseUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CATEGORIES = ["Stationery", "Supplies", "Electronics"];
const ASSIGNED_TO_OPTIONS = ["Admin", "Teacher", "Secretary"];

const EMPTY_FORM = {
  itemId: "", itemName: "", category: "", quantity: "",
  location: "", lastUpdated: "", description: "", storageLocation: "", assignedTo: ""
};

const AddInventoryDialog = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field) => (e) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async () => {
    if (!form.itemName || !form.category || !form.quantity) {
      setError("Please fill all required fields");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await postData("admin/inventory/", form);
      onSuccess("Inventory item added successfully");
      setForm(EMPTY_FORM);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to add item");
    }
    setLoading(false);
  };

  const handleClose = () => {
    setForm(EMPTY_FORM);
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth TransitionComponent={Transition}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" fontWeight="bold">Add Inventory Item</Typography>
        <IconButton onClick={handleClose}><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={6}>
            <TextField label="Item ID" fullWidth size="small"
              value={form.itemId} onChange={handleChange("itemId")} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Item Name *" fullWidth size="small"
              value={form.itemName} onChange={handleChange("itemName")} />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Category *</InputLabel>
              <Select value={form.category} label="Category *" onChange={handleChange("category")}>
                {CATEGORIES.map(c => (
                  <MenuItem key={c} value={c}>{c}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField label="Quantity *" fullWidth size="small" type="number"
              value={form.quantity} onChange={handleChange("quantity")} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Location" fullWidth size="small"
              value={form.location} onChange={handleChange("location")} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Last Updated" fullWidth size="small" type="date"
              value={form.lastUpdated} onChange={handleChange("lastUpdated")}
              InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Assigned To</InputLabel>
              <Select value={form.assignedTo} label="Assigned To" onChange={handleChange("assignedTo")}>
                <MenuItem value="">-- None --</MenuItem>
                {ASSIGNED_TO_OPTIONS.map(opt => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField label="Storage Location" fullWidth size="small"
              value={form.storageLocation} onChange={handleChange("storageLocation")} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Product Description" fullWidth size="small" multiline rows={3}
              value={form.description} onChange={handleChange("description")} />
          </Grid>
        </Grid>
        {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="outlined"
          sx={{ color: "#f44336", borderColor: "#f44336", textTransform: "none" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ backgroundColor: "#4caf50", textTransform: "none",
            "&:hover": { backgroundColor: "#388e3c" } }}>
          {loading ? "Saving..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddInventoryDialog;
